import { toast } from '@ui/Toast';

export interface NotificationOptions {
  duration?: number;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export class NotificationService {

  static success(message: string, title?: string, options?: NotificationOptions) {
    return toast({
      title: title || 'Éxito',
      description: message,
      variant: 'success',
      duration: options?.duration || 3000,
    });
  }

  // Notificaciones de error
  static error(message: string, title?: string, options?: NotificationOptions) {
    return toast({
      title: title || 'Error',
      description: message,
      variant: 'destructive',
      duration: options?.duration || 7000,
    });
  }

  // Notificaciones de advertencia
  static warning(message: string, title?: string, options?: NotificationOptions) {
    return toast({
      title: title || 'Advertencia',
      description: message,
      variant: 'default',
      duration: options?.duration || 6000,
    });
  }


  static info(message: string, title?: string, options?: NotificationOptions) {
    return toast({
      title: title || 'Información',
      description: message,
      variant: 'default',
      duration: options?.duration || 4000,
    });
  }

  // Notificaciones de carga
  static loading(message: string) {
    return toast({
      title: 'Cargando...',
      description: message,
      variant: 'default',
      duration: 3000,
    });
  }


} 